var map = {
	"./": [
		1608,
		608
	],
	"./about-us": [
		2308,
		995,
		346
	],
	"./about-us/": [
		2308,
		995,
		346
	],
	"./about-us/index": [
		2308,
		995,
		346
	],
	"./about-us/index.vue": [
		2308,
		995,
		346
	],
	"./afterpay": [
		8061,
		995,
		741
	],
	"./afterpay/": [
		8061,
		995,
		741
	],
	"./afterpay/index": [
		8061,
		995,
		741
	],
	"./afterpay/index.vue": [
		8061,
		995,
		741
	],
	"./checkout-payment": [
		9849,
		134,
		849
	],
	"./checkout-payment/": [
		9849,
		134,
		849
	],
	"./checkout-payment/index": [
		9849,
		134,
		849
	],
	"./checkout-payment/index.vue": [
		9849,
		134,
		849
	],
	"./checkout-payment/pay-button": [
		5134,
		134
	],
	"./checkout-payment/pay-button.vue": [
		5134,
		134
	],
	"./clearpay": [
		1703,
		995,
		964
	],
	"./clearpay/": [
		1703,
		995,
		964
	],
	"./clearpay/index": [
		1703,
		995,
		964
	],
	"./clearpay/index.vue": [
		1703,
		995,
		964
	],
	"./color-chart": [
		4547,
		112,
		478
	],
	"./color-chart/": [
		4547,
		112,
		478
	],
	"./color-chart/index": [
		4547,
		112,
		478
	],
	"./color-chart/index.vue": [
		4547,
		112,
		478
	],
	"./color-chart/main": [
		9112,
		112,
		538
	],
	"./color-chart/main.vue": [
		9112,
		112,
		538
	],
	"./contact-us": [
		7445,
		445
	],
	"./contact-us/": [
		7445,
		445
	],
	"./contact-us/index": [
		7445,
		445
	],
	"./contact-us/index.vue": [
		7445,
		445
	],
	"./faq": [
		6713,
		713
	],
	"./faq/": [
		6713,
		713
	],
	"./faq/index": [
		6713,
		713
	],
	"./faq/index.vue": [
		6713,
		713
	],
	"./index": [
		1608,
		608
	],
	"./index.vue": [
		1608,
		608
	],
	"./klarna": [
		8911,
		911
	],
	"./klarna/": [
		8911,
		911
	],
	"./klarna/index": [
		8911,
		911
	],
	"./klarna/index.vue": [
		8911,
		911
	],
	"./order-cancellation": [
		8863,
		863
	],
	"./order-cancellation/": [
		8863,
		863
	],
	"./order-cancellation/components/cancellation-form": [
		7303,
		303
	],
	"./order-cancellation/components/cancellation-form.vue": [
		7303,
		303
	],
	"./order-cancellation/components/cancellation-time": [
		9896,
		896
	],
	"./order-cancellation/components/cancellation-time.vue": [
		9896,
		896
	],
	"./order-cancellation/components/cancellation-tips": [
		5099,
		99
	],
	"./order-cancellation/components/cancellation-tips.vue": [
		5099,
		99
	],
	"./order-cancellation/index": [
		8863,
		863
	],
	"./order-cancellation/index.vue": [
		8863,
		863
	],
	"./payment-methods": [
		3948,
		948
	],
	"./payment-methods/": [
		3948,
		948
	],
	"./payment-methods/desc": [
		2031,
		731
	],
	"./payment-methods/desc.vue": [
		2031,
		731
	],
	"./payment-methods/index": [
		3948,
		948
	],
	"./payment-methods/index.vue": [
		3948,
		948
	],
	"./paypal": [
		5916,
		916
	],
	"./paypal-page": [
		1787,
		787
	],
	"./paypal-page/": [
		1787,
		787
	],
	"./paypal-page/index": [
		1787,
		787
	],
	"./paypal-page/index.vue": [
		1787,
		787
	],
	"./paypal/": [
		5916,
		916
	],
	"./paypal/index": [
		5916,
		916
	],
	"./paypal/index.vue": [
		5916,
		916
	],
	"./privacy-policy": [
		8604,
		604
	],
	"./privacy-policy/": [
		8604,
		604
	],
	"./privacy-policy/index": [
		8604,
		604
	],
	"./privacy-policy/index.vue": [
		8604,
		604
	],
	"./project-tailor-made": [
		802,
		995,
		730
	],
	"./project-tailor-made/": [
		802,
		995,
		730
	],
	"./project-tailor-made/components/parallax": [
		6995,
		995,
		251
	],
	"./project-tailor-made/components/parallax.vue": [
		6995,
		995,
		251
	],
	"./project-tailor-made/index": [
		802,
		995,
		730
	],
	"./project-tailor-made/index.vue": [
		802,
		995,
		730
	],
	"./returns-refund": [
		5354,
		354
	],
	"./returns-refund/": [
		5354,
		354
	],
	"./returns-refund/index": [
		5354,
		354
	],
	"./returns-refund/index.vue": [
		5354,
		354
	],
	"./shipping-info": [
		3204,
		204
	],
	"./shipping-info/": [
		3204,
		204
	],
	"./shipping-info/components/shipping-about": [
		4179,
		179
	],
	"./shipping-info/components/shipping-about.vue": [
		4179,
		179
	],
	"./shipping-info/components/shipping-rush-order": [
		1584,
		584
	],
	"./shipping-info/components/shipping-rush-order.vue": [
		1584,
		584
	],
	"./shipping-info/components/shipping-time": [
		6122,
		122
	],
	"./shipping-info/components/shipping-time.vue": [
		6122,
		122
	],
	"./shipping-info/index": [
		3204,
		204
	],
	"./shipping-info/index.vue": [
		3204,
		204
	],
	"./size-guide": [
		5009,
		9
	],
	"./size-guide/": [
		5009,
		9
	],
	"./size-guide/components/dress": [
		2499,
		499
	],
	"./size-guide/components/dress.vue": [
		2499,
		499
	],
	"./size-guide/components/flower-girls": [
		4469,
		469
	],
	"./size-guide/components/flower-girls.vue": [
		4469,
		469
	],
	"./size-guide/components/jackets-wraps": [
		8095,
		95
	],
	"./size-guide/components/jackets-wraps.vue": [
		8095,
		95
	],
	"./size-guide/components/junior-bridesmaid": [
		3216,
		216
	],
	"./size-guide/components/junior-bridesmaid.vue": [
		3216,
		216
	],
	"./size-guide/components/menSuits": [
		9066,
		66
	],
	"./size-guide/components/menSuits.vue": [
		9066,
		66
	],
	"./size-guide/components/shoes": [
		2132,
		132
	],
	"./size-guide/components/shoes.vue": [
		2132,
		132
	],
	"./size-guide/index": [
		5009,
		9
	],
	"./size-guide/index.vue": [
		5009,
		9
	],
	"./size/dress": [
		8823,
		823
	],
	"./size/dress.vue": [
		8823,
		823
	],
	"./size/flower-girl-dress": [
		6634,
		634
	],
	"./size/flower-girl-dress.vue": [
		6634,
		634
	],
	"./size/jewelry": [
		4293,
		293
	],
	"./size/jewelry.vue": [
		4293,
		293
	],
	"./size/lingerie": [
		4086,
		86
	],
	"./size/lingerie.vue": [
		4086,
		86
	],
	"./size/menSuits": [
		8967,
		967
	],
	"./size/menSuits.vue": [
		8967,
		967
	],
	"./size/pajamas": [
		7682,
		682
	],
	"./size/pajamas.vue": [
		7682,
		682
	],
	"./size/rings": [
		7625,
		625
	],
	"./size/rings.vue": [
		7625,
		625
	],
	"./size/shoes": [
		6744,
		744
	],
	"./size/shoes.vue": [
		6744,
		744
	],
	"./size/wrap": [
		1342,
		342
	],
	"./size/wrap.vue": [
		1342,
		342
	],
	"./terms-conditions": [
		4657,
		657
	],
	"./terms-conditions/": [
		4657,
		657
	],
	"./terms-conditions/index": [
		4657,
		657
	],
	"./terms-conditions/index.vue": [
		4657,
		657
	],
	"./ticket": [
		2067,
		67
	],
	"./ticket/": [
		2067,
		67
	],
	"./ticket/index": [
		2067,
		67
	],
	"./ticket/index.vue": [
		2067,
		67
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7611;
module.exports = webpackAsyncContext;